<div [ngClass]="snackBarClass">
    <div class="icon-wrp">
        <i [ngClass]="iconClass"></i>
    </div>
    <div class="content">
        <span class="title">{{ data.title }}</span>
        <span class="description">{{ data.description }}</span>
    </div>
    <div class="close-wrp">
        <button class="icon-button"  (click)="dismissSnackBar()"><i class="fa fa-times"></i></button>
    </div>
</div>
